import {createContext} from 'react';

export const AuthContext = createContext({
  isReady: false,
  isAuthenticated: false,
  authState: null
});
